jQuery(function ($) {

    var currentVal = "1";
    var timeoutID = null;

    $('.news-taxonomy-ul .product-list').on('click', function (e) {
        ajaxTestFunction(getCurrentPageNum(), this);
    });

    $('.search-box')
        .on('keydown', function (e) {
            if (e.which == 9) { //tab
                ajaxTestFunction(getCurrentPageNum());
            }
        })
        .on('keypress', function (e) {
            if (e.which == 13) {  // enter
                ajaxTestFunction(getCurrentPageNum());
            }
        });

    $('.search-icon').on('click', function (e) {
        searchbox_val = $('.search-box').val();
        timeoutID = setTimeout(findMember(searchbox_val), 500);
    });

    $(document).on('click', '.page-news-pagination .page-link', function (e) {
        e.preventDefault();
        pageval = $(this).attr('data-href');
        ajaxTestFunction(pageval);
        $(window).scrollTop($("#layout-content").offset().top);
    });

    function ajaxTestFunction(page_num, this_var) {
        if (isNaN(page_num)) {
            page_num = 1;
        }
        var filter_val1 = '';
        var search_val = $('#s').val();
        var taxonomy1;

        if ($(this_var).hasClass('type')) {
            if ($(this_var).prop("checked") === true) {
                filter_val1 = $(this_var).val();
            }
            taxonomy1 = $('.type').attr('data');
        } else {
            $.each($('.type'), function () {
                if ($(this).prop("checked") == true) {
                    filter_val1 = $(this).val();
                }
                taxonomy1 = $('.type').attr('data');
            });
        }

        $.ajax({
            cache: true,
            type: 'GET',
            url: waystar_params.endpoint,
            data: {
                _ajax_nonce: waystar_params.security,
                action: 'filter_news',
                filter_value1: filter_val1,
                taxonomy_value1: taxonomy1,
                search_value: search_val,
                paged: page_num || 1,
                current_url: window.location.href
            },
            success: function (response) {
                $('.news-list-wrapper').html(response);
                lazy_load();
            },
            error: function (jqXHR, textStatus, errorThrown, response) {
                $('.news-list-wrapper').html(textStatus);
            }
        });
    }

    function findMember(str) {
        var paged = /[\?&]paged=(\d+)/.test(this.href) && RegExp.$1;

        ajaxTestFunction(paged);
    }

    function getCurrentPageNum() {
        return $('.page-news-pagination .current').attr('data-href');
    }

});